import config from '@/config'
import convertSession from './session'

const ALERT_TITLES = {
  [config.coachingStatus.NEW]: 'Einladung wurde an den Coach gesendet.',
  [config.coachingStatus.PENDING]: 'Anfrage wird vom Landesinstitut bearbeitet.',
  [config.coachingStatus.ACTIVE]: 'Coaching ist aktiv.',
  [config.coachingStatus.FINISHED]: 'Bewertung vom Coachee ausstehend.',
  [config.coachingStatus.RATED]: 'Coaching wurde beendet.',
  [config.coachingStatus.ARCHIVED]: 'Coaching wurde archiviert.',
  [config.coachingStatus.CLOSED]: 'Coaching wurde abgelehnt.'
}

const ALERT_TYPES = {
  [config.coachingStatus.FINISHED]: 'warning',
  [config.coachingStatus.RATED]: 'success',
  [config.coachingStatus.ARCHIVED]: 'warning',
  [config.coachingStatus.CLOSED]: 'error'
}

/**
 * Convert data from coaching API to internal format
 * @param {Object} coaching Coaching API data
 * @param {Number} coaching.id ID
 * @param {String} coaching.state Status
 * @param {Object} coaching.coach Coach data
 * @param {Number} coaching.coach.id Coach ID
 * @param {Object} coaching.coach.user Coach user data
 * @param {String} coaching.coach.user.first_name First name of coach
 * @param {String} coaching.coach.user.last_name Last name of coach
 * @param {Object} coaching.coachee Coachee data
 * @param {Number} coaching.coachee.id Coachee ID
 * @param {Object} coaching.coachee.user Coachee user data
 * @param {String} coaching.coachee.user.first_name First name of coachee
 * @param {String} coaching.coachee.user.last_name Last name of coachee
 * @param {String} coaching.coaching_type_display Type
 * @param {String} coaching.topic Topic
 * @param {String} coaching.aim Objective
 * @param {String} coaching.start_date Start date
 * @param {String} coaching.end_data End date
 * @param {String} coaching.acceptance_date End date
 * @param {Number} coaching.estimate Estimated time needed
 * @param {String} coaching.termination_reason_display Reason for finishing
 * @param {String} coaching.termination_comment Comment for finishing
 * @param {Number} coaching.rating Rating
 * @param {String} coaching.rating_comment Comment for rating
 * @param {Array} coaching.sessions Sessions
 * @returns {Object} Converted coaching data
 */
export default function (coaching) {
  const sessions = coaching.sessions
    .map(convertSession)
    .sort((a, b) => a.timeStart - b.timeStart)

  const worked = sessions
    .filter(session => session.status === config.sessionStatus.BOTH_ACCEPTED)
    .reduce((acc, session) => {
      acc = acc + session.duration
      return acc
    }, 0)

  const data = {
    id: coaching.id,
    status: coaching.state,
    alert: {
      title: ALERT_TITLES[coaching.state],
      type: ALERT_TYPES[coaching.state]
    },
    type: coaching.coaching_type_display,
    topic: coaching.topic,
    objective: coaching.aim,
    dateStart: new Date(coaching.start_date),
    dateEnd: new Date(coaching.end_date),
    dateAcceptance: coaching.acceptance_date && new Date(coaching.acceptance_date),
    estimate: coaching.estimate,
    worked,
    finishReason: coaching.termination_reason_display,
    finishComment: coaching.termination_comment,
    rating: coaching.rating,
    ratingComment: coaching.rating_comment,
    sessions
  }

  if (coaching.coach) {
    data.coach = {
      id: coaching.coach.id,
      name: `${coaching.coach.user.first_name} ${coaching.coach.user.last_name}`
    }
  } else {
    data.coach = {
      name: 'Profil gelöscht'
    }
  }

  if (coaching.coachee) {
    data.coachee = {
      id: coaching.coachee.id,
      name: `${coaching.coachee.user.first_name} ${coaching.coachee.user.last_name}`
    }
  } else {
    data.coachee = {
      name: 'Profil gelöscht'
    }
  }

  return data
}
